export enum TypeDemandes {
  En_attente,
  En_traitement,
  Traitees,
  Archivees,
  Incomplet
}
